var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.89111V5.33323C9.66671 5.79994 9.66671 6.0333 9.75754 6.21156C9.83743 6.36836 9.96491 6.49584 10.1217 6.57574C10.3 6.66656 10.5333 6.66656 11 6.66656H14.4422M9.66671 14.1665H4.66671M11.3334 10.8332H4.66671M14.6667 8.32336V14.3332C14.6667 15.7333 14.6667 16.4334 14.3942 16.9681C14.1545 17.4386 13.7721 17.821 13.3017 18.0607C12.7669 18.3332 12.0668 18.3332 10.6667 18.3332H5.33337C3.93324 18.3332 3.23318 18.3332 2.6984 18.0607C2.22799 17.821 1.84554 17.4386 1.60586 16.9681C1.33337 16.4334 1.33337 15.7333 1.33337 14.3332V5.6665C1.33337 4.26637 1.33337 3.56631 1.60586 3.03153C1.84554 2.56112 2.22799 2.17867 2.6984 1.93899C3.23318 1.6665 3.93324 1.6665 5.33337 1.6665H8.00985C8.62133 1.6665 8.92707 1.6665 9.21479 1.73558C9.46988 1.79682 9.71374 1.89783 9.93742 2.0349C10.1897 2.18951 10.4059 2.4057 10.8383 2.83808L13.4951 5.49493C13.9275 5.92731 14.1437 6.1435 14.2983 6.39579C14.4354 6.61947 14.5364 6.86333 14.5976 7.11842C14.6667 7.40614 14.6667 7.71188 14.6667 8.32336Z",
    stroke: "#ACB6C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDark);
export default __webpack_public_path__ + "static/media/pdfDark.76bbdaf72bfb3ba32a04e9d064babdfe.svg";
export { ForwardRef as ReactComponent };